<template>
	<div class="el-checkbox-group" role="group" aria-label="checkbox-group">
		<dms-check v-for="(item, idx) in items" :key="item.Value" :placeholder="item.Text" :value="computedValue[idx]" :disabled="item.Disabled"
			@update:value="updateValue(idx, item, $event)" />
	</div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
	name: 'DmsCheckGroup',
	componentName: 'DmsCheckGroup',
	props: {
		value: {
			type: Array,
			required: true,
		},
		items: {
			type: Array,
			required: true,
		},
	},
	computed: {
		computedValue() {
			return this.items.map((e) => this.value.includes(e.Value));
		},
	},
	methods: {
		updateValue(index, item, value) {
			const output = this.value.filter((e) => e !== item.Value);

			if (value) {
				output.push(item.Value);
			}

			this.$emit('update:value', output);
		},
	},
});
</script>
